import { ButtonSize } from '@farmasiet/frontendcore-reactcomponents';
import classNames from 'classnames';
import React from 'react';

import { NavigationTrackerButtonLink } from '../../ReactComponents/NavigationTracker/NavigationTrackerButtonLink';
import { NavigationTrackerLink } from '../../ReactComponents/NavigationTracker/NavigationTrackerLink';
import { RxBannerViewModel } from './RxBannerViewModel.csharp';

export const RxBanner = ({ heading, description, buttonLink, textLink, compactVersion, maintenance }: RxBannerViewModel) => {
    heading = maintenance.showMessage ? maintenance.header : heading;
    description = maintenance.showMessage ? maintenance.message : description;

    return (
        <div
            className={classNames('RxBanner', {
                'RxBanner--NoDescription': !description,
                'RxBanner--NoTextLink': !textLink,
                'RxBanner--Maintenance': maintenance.showMessage,
                'RxBanner--Compact': !maintenance.showMessage && compactVersion
            })}
        >
            <div className="RxBanner__Wrapper">
                <div className="RxBanner__Inner">
                    <div className="RxBanner__Image" />
                    <div className="RxBanner__Content">
                        {heading && <div className="RxBanner__Heading">{heading}</div>}
                        {description && (!compactVersion || maintenance.showMessage) && <div className="RxBanner__Description">{description}</div>}
                    </div>
                    {!maintenance.showMessage && (
                        <>
                            <div className={classNames('RxBanner__ButtonLink RxBanner__ButtonLink--Small')}>
                                <NavigationTrackerButtonLink href={buttonLink.href} size={ButtonSize.Small} target={buttonLink.target} source="RxBanner">
                                    {buttonLink.text}
                                </NavigationTrackerButtonLink>
                            </div>
                            <div className={classNames('RxBanner__ButtonLink RxBanner__ButtonLink--Medium')}>
                                <NavigationTrackerButtonLink href={buttonLink.href} size={ButtonSize.Medium} target={buttonLink.target} source="RxBanner">
                                    {buttonLink.text}
                                </NavigationTrackerButtonLink>
                            </div>
                            {textLink && (
                                <div className="RxBanner__TextLink">
                                    <NavigationTrackerLink href={textLink.href} target={textLink.target} source="RxBanner">
                                        {textLink.text}
                                    </NavigationTrackerLink>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};
